import { Link, useNavigate, useLocation } from 'react-router-dom';
import MobileMenu from './MobileMenu';

function Navigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    return (
        <header className="app-header">
            <div className="header-content">
                <Link to="/" className="header-title">
                    <h1>Political Health Tracker</h1>
                    <p>Monitor the wellness of our democracy</p>
                </Link>

                <div className="header-actions">
                    {!isHomePage && (
                        <button
                            onClick={() => navigate(-1)}
                            className="back-button"
                        >
                            ← Back
                        </button>
                    )}

                    {/* This should render the burger menu */}
                    <MobileMenu />
                </div>
            </div>
        </header>
    );
}

export default Navigation;